import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  display: 'flex',
  flexDirection: 'column',
  gap: 1,
  justifyContent: 'center',
  alignItems: 'center',
  height: '100vh',
};
